export const EndPointURL = 'https://devapi2.kpostindia.com/v2' // KPOST URL

// export const AdminURL = `http://192.168.0.38:9595` // Jagan Local URL

export const AdminURL = `https://adminmodule.kpostindia.com` // Live URL

//    
// export const AdminURL = `http://192.168.137.139:9092` // Karan Local URL   

// export const AdminURL = `http://192.168.2.128:9092` // Kirubanithi Local URL   

// export const LoginURL = `http://192.168.2.24:8989/v2` // Karan Local URL   

export const LoginURL = `https://devapi2.kpostindia.com/v2` // Live URL   
